export interface UAFlags {
  /** 粗略识别“手机/移动端浏览器” */
  isMobile: boolean;
  /** 是否 Android */
  isAndroid: boolean;
  /** 是否 iOS/iPadOS */
  isIOS: boolean;
  /** 是否微信内置浏览器 */
  isWeChat: boolean;
}

/**
 * 是否为 Android + 微信内置浏览器（常见 WebView 下载/Blob 兼容问题场景）
 */
export function isAndroidWeChat(userAgent?: string): boolean {
  return getUAFlags(userAgent).isAndroid && getUAFlags(userAgent).isWeChat;
}

/**
 * 通过 UA 识别是否为移动端（尽量避免仅靠屏幕宽度误判）
 *
 * 注意：
 * - UA 识别永远不是 100% 准确，但对“手机端降级下载策略”足够可靠
 * - iPadOS 有时会伪装成 Mac，需要结合触控能力兜底
 */
export function getUAFlags(userAgent?: string): UAFlags {
  const ua = (userAgent ?? '').toLowerCase();

  const isAndroid = ua.includes('android');
  const isIPhone = ua.includes('iphone');
  const isIPod = ua.includes('ipod');
  const isIEMobile = ua.includes('iemobile') || ua.includes('windows phone');
  const isOperaMini = ua.includes('opera mini');
  const isWeChat = ua.includes('micromessenger');

  // iPad / iPadOS：既匹配 iPad UA，也处理“Macintosh + Mobile”这种 iPadOS UA
  const isIPad = ua.includes('ipad') || (ua.includes('macintosh') && ua.includes('mobile'));

  // 兜底：iPadOS 13+ 可能是 Macintosh，但具备触控点数
  const hasTouch = typeof navigator !== 'undefined' && (navigator.maxTouchPoints ?? 0) > 1;

  const isIOS = isIPhone || isIPod || isIPad || (ua.includes('macintosh') && hasTouch);

  const isMobile = isAndroid || isIOS || isIEMobile || isOperaMini || ua.includes('mobile');

  return {
    isMobile,
    isAndroid,
    isIOS,
    isWeChat,
  };
}
